export const randomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const identifyIcon = (value: string) => {
  switch (value) {
    case 'pending':
      return 'mdi-exclamation-thick';
    case 'sent':
      return 'mdi-package-up';
    case 'ready':
      return 'mdi-check-circle';
    case 'in-progress':
      return 'mdi-key';
    case 'cancelled':
      return 'mdi-close-circle';
    case 'canceled':
      return 'mdi-close-circle';
    case 'draft':
      return 'mdi-pencil';
    case 'closed':
      return 'mdi-flag';
    case 'checked-in':
      return 'mdi-room-service';
    case 'paid':
      return 'mdi-check-circle';
    default:
      return '';
  }
};

export const getStatusColor = (status: string) => {
  switch (status.toString()) {
    case 'pending':
      return 'orange';
    case 'sent':
      return 'orange';
    case 'blocked':
      return 'primaryDefault';
    case 'accepted':
      return 'success';
    case 'ready':
      return 'success';
    case 'paid':
      return 'success';
    case 'in-progress':
      return 'info';
    case 'draft':
      return 'default';
    case 'cancelled':
      return 'error';
    case 'canceled':
      return 'error';
    case 'closed':
      return 'default';
    case 'checked-in':
      return 'default';
    default:
      return '';
  }
};
